import React from 'react';
import { useInternalNavigate } from '../../../utils/navigate/useNavigate';
import { isEditorActive, Link as JssLink } from '@sitecore-jss/sitecore-jss-react';
import { useDispatch } from 'react-redux';

const Link = ({ fields, params }) => {
  const navigate = useInternalNavigate();
  const dispatch = useDispatch();
  const clsName =
    fields.centreAligned?.value === true ? 'vds-text-centre-aligned' : 'vds-styled-link';

  const handleClick = event => {
    if (fields.reduxDispatch?.value) {
      event.preventDefault();
      const dispatchData = JSON.parse(fields.reduxDispatch.value);
      dispatch(dispatchData);
      return false;
    }
    if (params?.isInternal && fields.link?.value?.href) {
      event.preventDefault();
      navigate(fields.link.value.href);
      return false;
    }
    return true;
  };

  const renderLink = () => {
    return <JssLink data-testid={fields.testid?.value} field={fields.link} onClick={handleClick} />;
  };

  if (fields.centreAligned?.value === true) {
    return <div className={`vds-form__group ${clsName}`}>{renderLink()}</div>;
  } else {
    return <p>{renderLink()}</p>;
  }
};
export default Link;
